var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useIncreaseDurationMutation } from '../../../../store/services/breakoutRoomApi';
import { IncreaseBreakoutRoomDurationReq } from '../../../../helpers/proto/plugnmeet_breakout_room_pb';
const ExtendDuration = ({ breakoutRoomId }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const [duration, setDuration] = useState(5);
    const [disable, setDisable] = useState(false);
    const [increaseDuration, { isLoading, data }] = useIncreaseDurationMutation();
    useEffect(() => {
        setDisable(!!isLoading);
    }, [isLoading]);
    useEffect(() => {
        if (data) {
            if (data.status) {
                toast(t('breakout-room.duration-extended'), {
                    type: 'info',
                });
            }
            else {
                toast(t(data.msg), {
                    type: 'error',
                });
            }
        }
    }, [data]);
    const extendDuration = () => {
        increaseDuration(new IncreaseBreakoutRoomDurationReq({
            breakoutRoomId: breakoutRoomId,
            duration: BigInt(duration),
        }));
    };
    return (_jsxs("div", { className: "extend-time-wrapper flex items-center mr-2 mb-2", children: [_jsx("input", { value: duration, onChange: (e) => setDuration(Number(e.currentTarget.value)), placeholder: t('breakout-room.extend-duration').toString(), className: "w-full max-w-[100px] sm:max-w-[140px] block outline-none border border-solid border-secondaryColor rounded py-1 px-2 h-9 bg-transparent dark:text-darkText dark:border-darkText" }), _jsx("button", { onClick: extendDuration, disabled: disable, className: "ml-2 sm:ml-4 w-[180px] text-center py-1 px-3 h-8 text-xs transition ease-in bg-primaryColor hover:bg-secondaryColor text-white font-semibold rounded-lg", children: t('breakout-room.extend-duration') })] }));
};
_react_refresh_temp_1 = ExtendDuration;
$RefreshReg$(_react_refresh_temp_1, "ExtendDuration");
_react_refresh_temp_2(ExtendDuration, "/RCch+MB2Pm3YZxEURD9jYVNHWw=", false, () => [useTranslation, useIncreaseDurationMutation]);
export default ExtendDuration;
